<template>
  <Layout>
    <table id="tablePreview" class="table" :key="'tbl'+refresher">
      <thead>
        <tr>
          <th width="5%">#</th>
          <th width="30%">Login</th>
          <th width="30%">Typ</th>
        </tr>
      </thead>
      <tbody>
        <!-- 001 data row -->
        <tr v-for="(item,index) in users" @click="mthSetEditMode(item,index)" :key="'tr'+index">
          <template v-if="index!=editindex">
            <td>{{index+1}}</td>
            <td>{{item.login}}</td>
            <td>{{item.typ}}</td>
          </template>
          <template v-else>
            <td>(edycja)</td>
            <td>
              <input v-model="newUserName" placeholder="nazwa" />
              <input v-model="newUserPassword" placeholder="hasło" type="password" />
            </td>
            <td>
              <select v-model="newUserType" placeholder="typ">
                <option value></option>
                <option value="magazyn">magazyn</option>
                <option value="admin">admin</option>
              </select>
            </td>
          </template>
        </tr>
        <!-- 002 add new row -->
        <tr v-if="addNewUserMode">
          <td>(nowy)</td>
          <td>
            <input v-model="newUserName" placeholder="nazwa" />
            <input v-model="newUserPassword" placeholder="hasło" type="password" />
          </td>
          <td>
            <select v-model="newUserType" placeholder="typ">
              <option value></option>
              <option value="magazyn">magazyn</option>
              <option value="admin">admin</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 003 buttons -->
    <mdb-btn
      v-if="!addNewUserMode && !editUserMode"
      icon="plus"
      gradient="blue"
      @click="mthNewButtonClick"
    >NOWY</mdb-btn>
    <nobr>
      <mdb-btn
        v-if="addNewUserMode || editUserMode"
        icon="save"
        gradient="purple"
        @click="mthSaveButtonClicked"
      >ZAPISZ</mdb-btn>
      <mdb-btn
        v-if="addNewUserMode || editUserMode"
        icon="save"
        gradient="blue"
        @click="mthCancelClick"
      >ANULUJ</mdb-btn>
    </nobr>
  </Layout>
</template>

<script>
import { mdbIcon, mdbBtn } from "mdbvue";
export default {
  name: "users",
  data() {
    return {
      refresher: 0,
      users: [],
      addNewUserMode: false,
      editUserMode: false,
      newUserId: -1,
      newUserName: "",
      newUserPassword: "",
      newUserType: "",
      editindex: -1
    };
  },
  created() {
    this.mthGetUsers();
  },
  methods: {
    mthCancelClick() {
      this.addNewUserMode = false;
      this.editUserMode = false;
      this.editindex = -1;
      //this.$forceUpdate();
    },
    mthSetEditMode(item, index) {
      if (!this.editUserMode) {
        this.editUserMode = true;
        this.addNewUserMode = false;
        this.editindex = index;
        this.newUserName = item.login;
        this.newUserType = item.typ;
        this.newUserId = item.id;
      }
    },
    mthSaveNewUserApiCall() {
      var apiurl = this.$config.API_URL + "/swmsaveuser";
      var that = this;

      this.$axios({
        method: "post",
        url: apiurl,
        data: {
          id: this.newUserId,
          login: this.newUserName,
          password: this.newUserPassword,
          type: this.newUserType
        }
      })
        .then(function(response) {
          console.log(response.data);
          that.mthGetUsers();

          //that.users = response.data;
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthValidateNewUserData() {
      if (this.newUserName == "") return "Wpisz nazwę nowego użytkownika";
      if (this.addNewUserMode && this.newUserPassword == "")
        return "Wpisz hasło nowego użytkownika";
      if (this.newUserType == "") return "Wybierz typ nowego użytkownika";

      return "OK";
    },
    mthSaveButtonClicked() {
      var validationResult = this.mthValidateNewUserData();

      if (validationResult == "OK") {
        this.mthSaveNewUserApiCall();
        this.addNewUserMode = false;
        this.editUserMode = false;
      } else {
        this.$swal("Błąd walidacji: " + validationResult);
      }

      this.addNewUserMode = false;
      this.editUserMode = false;
      this.editindex = -1;
      this.newUserId = -1;
    },
    mthNewButtonClick() {
      this.addNewUserMode = true;
      this.editUserMode = false;
      this.editindex = -1;
      this.newUserId = -1;
    },
    mthGetUsers() {
      var apiurl = this.$config.API_URL + "/swmusers";
      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          that.users = [];
          //console.log(response.data);
          that.users = response.data;
          that.refresher++;
        })
        .catch(function(error) {
          console.log(error);
          //that.msg = "Brak połączenia z API (" + error + ").";
        });
    }
  },
  components: { mdbIcon, mdbBtn }
};
</script>

<style scoped>
</style>></style>